import { render, staticRenderFns } from "./WorkbookReportPreview.vue?vue&type=template&id=c57b1d46"
import script from "./WorkbookReportPreview.vue?vue&type=script&lang=js"
export * from "./WorkbookReportPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports